/* eslint-disable object-curly-newline */
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  setErrorInfos({ commit }, { message, httpStatusCode, appCode }) {
    return storeActionCommit(commit, 'setErrorInfos')({ message, httpStatusCode, appCode });
  },

  resetErrorHandlingState({ commit }) {
    return storeActionCommit(commit, 'resetState')();
  },
};
